import {
  List,
  SimpleForm,
  TextInput,
  Datagrid,
  Edit,
  TextField,
  NumberField,
  useRecordContext,
} from 'react-admin'
import { CustomToolbar, ExtraPagination } from './utils'
import { RichTextInput } from 'ra-input-rich-text'

export const VarsList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    exporter={false}
    pagination={<ExtraPagination />}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="Id" />
      <TextField source="name" label="Nom" />
      <TextField source="value" label="Valeur" />
    </Datagrid>
  </List>
)

const Input = () => {
  const record = useRecordContext()
  if (record.id === '3') {
    return <RichTextInput source="value" />
  } else {
    return <TextInput source="value" />
  }
}

export const VarEdit = (props) => (
  <Edit {...props} bulkActionButtons={false}>
    <SimpleForm toolbar={<CustomToolbar />} variant="outlined">
      <NumberField source="id" label="Id" />
      <TextField source="name" label="Nom" />
      <Input />
    </SimpleForm>
  </Edit>
)
